export default __webpack_public_path__ + "static/media/Gyas's Conduit.7d8cf945.jpg";